// Test IDs for reviews & ratings (product, seller and buyer reviews) and the
// seller dashboard's lead list. Naming follows the directive in ./auth.js.

export const REVIEWS = {
  root: "reviews-section",
  summary: "reviews-summary",
  form: "reviews-form",
  starInput: "reviews-star-input",
  commentInput: "reviews-comment-input",
  submitButton: "reviews-submit-button",
  loginLink: "reviews-login-link",
  item: "reviews-item",
  deleteButton: "reviews-delete-button",
  empty: "reviews-empty",
  productRating: "reviews-product-rating",
  cardRating: "reviews-card-rating",
};

export const LEADS = {
  list: "leads-list",
  item: "leads-item",
  rateLink: "leads-rate-link",
};
